// Configuration for mapping Google Maps address components to PlaceDetails
export interface AddressComponentConfig {
  address: {
    types: string[];
    useShortName?: boolean;
    fallback?: string;
    alternativeTypes?: string[];
  };
  city: {
    types: string[];
    useShortName?: boolean;
    fallback?: string;
    alternativeTypes?: string[];
  };
  state: {
    types: string[];
    useShortName?: boolean;
    fallback?: string;
    alternativeTypes?: string[];
  };
  zipCode: {
    types: string[];
    useShortName?: boolean;
    fallback?: string;
    alternativeTypes?: string[];
  };
  country: {
    types: string[];
    useShortName?: boolean;
    fallback?: string;
    alternativeTypes?: string[];
  };
}

// Default configuration
export const DEFAULT_ADDRESS_CONFIG: AddressComponentConfig = {
  address: {
    types: ['street_number', 'route'],
    fallback: '',
    alternativeTypes: ['street_address', 'establishment']
  },
  city: {
    types: ['locality'],
    fallback: '',
    alternativeTypes: ['sublocality', 'administrative_area_level_2', 'neighborhood']
  },
  state: {
    types: ['administrative_area_level_1'],
    useShortName: true,
    fallback: '',
    alternativeTypes: ['administrative_area_level_2']
  },
  zipCode: {
    types: ['postal_code'],
    fallback: '',
    alternativeTypes: ['postal_code_suffix']
  },
  country: {
    types: ['country'],
    fallback: '',
    alternativeTypes: ['administrative_area_level_1']
  }
};
